{
  "checkout": {
    "title": "Commander",
    "cart_summary": "{{count}} article dans le panier",
    "cart_summary_plural": "{{count}} articles dans le panier",

    "tva": "TVA (18%)",
    "delivery_fee": "Frais de livraison",
    "service_fee": "Frais de service",
    "total": "Total",
    "cart_item": "{{count}} article dans le panier",
    "cart_item_plural": "{{count}} articles dans le panier",

    "steps": {
      "info": "Informations",
      "payment": "Paiement",
      "confirmation": "Confirmation",
      "aria_label": "Étapes de la commande"
    },

    "info": {
      "title": "Vos informations",
      "subtitle": "Renseignez vos coordonnées pour la livraison. Pas besoin de créer un compte.",
      "full_name_label": "Nom complet",
      "full_name_placeholder": "Abdou Diallo",
      "phone_label": "Téléphone *",
      "email_label": "E-mail (optionnel)",
      "address_label": "Adresse complète *",
      "address_placeholder": "Numéro, rue, villa / appartement",
      "quartier_label": "Quartier *",
      "quartier_placeholder": "Ex : Hann Mariste",
      "commune_label": "Commune *",
      "commune_placeholder": "Ex : Hann Bel-Air",
      "region_label": "Région *",
      "region_placeholder": "Sélectionnez votre région",
      "privacy_prefix": "J'accepte la",
      "privacy_link": "politique de confidentialité",
      "privacy_suffix": "de Djayma",
      "continue": "Continuer"
    },

    "validation": {
      "name_required": "Le nom complet doit contenir au moins 2 caractères",
      "phone_invalid": "Le numéro de téléphone doit être au format sénégalais (+221 XX XXX XX XX).",
      "email_invalid": "L'adresse e-mail n'est pas valide.",
      "address_required": "L'adresse est requise",
      "quartier_required": "Le quartier est requis",
      "commune_required": "La commune est requise",
      "region_required": "Veuillez sélectionner une région",
      "privacy_required": "Vous devez accepter la politique de confidentialité pour continuer.",
      "required": "Ce champ est requis"
    },

    "payment": {
      "title": "Mode de paiement",
      "subtitle": "Choisissez comment vous souhaitez régler votre commande.",
      "wave": "Wave",
      "wave_description": "Paiement mobile via Wave",
      "orange_money": "Orange Money",
      "orange_money_description": "Paiement mobile via Orange Money",
      "cash": "Paiement à la livraison",
      "cash_description": "Payez en espèces à la réception de votre commande",
      "phone_label": "Numéro {{provider}} *",
      "instructions": "Vous recevrez une demande de paiement sur ce numéro.",
      "total_label": "Total à payer",
      "back": "Retour",
      "confirm": "Confirmer le paiement",
      "cod_ineligible": {
        "max_amount": "Paiement à la livraison non disponible pour les commandes supérieures à {{amount}}.",
        "min_amount": "Paiement à la livraison disponible à partir de {{amount}}.",
        "zone_restricted": "Paiement à la livraison non disponible dans votre zone de livraison.",
        "max_pending": "Vous avez atteint le nombre maximum de commandes en attente avec paiement à la livraison.",
        "cod_disabled": "Le paiement à la livraison est temporairement indisponible.",
        "default": "Paiement à la livraison non disponible pour cette commande."
      }
    },

    "confirm_modal": {
      "title": "Confirmer le paiement",
      "subtitle": "Vérifiez les détails avant de valider",
      "amount_label": "Montant à payer",
      "method_label": "Mode de paiement",
      "phone_label": "Numéro de téléphone",
      "cod_notice": "Le paiement s'effectue en espèces à la réception de votre commande.",
      "mobile_money_notice": "Vous allez recevoir une demande de paiement {{provider}} sur votre téléphone. Validez-la pour confirmer la commande.",
      "cancel": "Annuler",
      "pay_now": "Payer {{amount}}",
      "processing": "Traitement en cours..."
    },

    "polling": {
      "waiting": "En attente de confirmation {{provider}}...",
      "waiting_description": "Veuillez valider le paiement sur votre téléphone. Cette page se met à jour automatiquement.",
      "confirmed": "Paiement confirmé !",
      "confirmed_description": "Votre paiement via {{provider}} a été reçu avec succès.",
      "timeout": "Paiement non reçu",
      "timeout_description": "Nous n'avons pas reçu la confirmation de votre paiement {{provider}} dans le délai imparti.",
      "failed": "Échec du paiement",
      "failed_message": "Le paiement a échoué. Veuillez réessayer.",
      "failed_generic": "Le paiement via {{provider}} a échoué.",
      "retry": "Réessayer"
    },

    "confirmation": {
      "success": "Commande confirmée !",
      "reference": "Votre référence de commande :",
      "summary": "Récapitulatif de commande",
      "subtotal_ht": "Sous-total HT",
      "tva": "TVA (18 %)",
      "delivery": "Frais de livraison",
      "total_ttc": "Total TTC",
      "delivery_address": "Adresse de livraison",
      "payment": "Paiement",
      "whatsapp_confirm": "Confirmer la commande via WhatsApp",
      "track_order": "Suivre ma commande",
      "back_home": "Retour à l'accueil"
    },

    "post_checkout": {
      "title": "Envie d'en profiter davantage ?",
      "create_account_prompt": "Créez un compte pour bénéficier de remises sur vos prochaines commandes ! Retrouvez aussi l'historique de vos achats et des adresses de livraison sauvegardées.",
      "create_account_button": "Créer mon compte",
      "dismiss": "Non merci, plus tard"
    },

    "errors": {
      "price_changed": "Les prix ont changé. Veuillez actualiser votre panier.",
      "network": "Erreur réseau. Veuillez vérifier votre connexion.",
      "order_failed": "Une erreur est survenue lors de la création de votre commande. Veuillez réessayer."
    },

    "delivery": {
      "title": "Votre adresse de livraison",
      "error_loading_zones": "Impossible de charger les zones de livraison. Veuillez réessayer.",
      "retry": "Réessayer",
      "no_zones": "Aucune zone de livraison disponible pour le moment.",
      "contact_us": "Contactez-nous au {{phone}} pour passer votre commande.",
      "back_to_cart": "Retour au panier",
      "continue_to_payment": "Continuer vers le paiement",
      "errors": {
        "name_required": "Le nom complet est requis",
        "name_too_short": "Le nom doit contenir au moins 3 caractères",
        "phone_required": "Le numéro de téléphone est requis",
        "phone_invalid": "Numéro sénégalais invalide (ex : 77 123 45 67)",
        "address_required": "L'adresse est requise",
        "address_too_short": "L'adresse doit contenir au moins 10 caractères",
        "commune_required": "La zone de livraison est requise",
        "zone_required": "Sélectionnez une zone de livraison",
        "method_unavailable": "Aucune méthode de livraison disponible pour cette zone",
        "privacy_required": "Vous devez accepter la politique de confidentialité"
      },
      "validation_summary": {
        "title": "Corrigez ces erreurs pour continuer"
      },
      "address_form": {
        "title": "Adresse de livraison",
        "full_name": "Nom complet",
        "full_name_placeholder": "Abdou Diallo",
        "phone": "Téléphone",
        "phone_placeholder": "77 123 45 67",
        "address": "Adresse complète",
        "address_placeholder": "Numéro, rue, villa / appartement",
        "commune": "Zone de livraison",
        "commune_placeholder": "Rechercher votre zone...",
        "email": "E-mail (optionnel)",
        "email_placeholder": "votre@email.com",
        "gps_button": "Me localiser automatiquement",
        "gps_denied": "Sélectionnez votre quartier dans la liste ci-dessus",
        "privacy_prefix": "J'accepte la",
        "privacy_link": "politique de confidentialité",
        "privacy_suffix": "de Djayma"
      },
      "method": {
        "title": "Mode de livraison",
        "standard": "Livraison standard",
        "express": "Livraison express"
      },
      "map": {
        "unavailable": "Carte non disponible",
        "load_error": "Impossible de charger la carte",
        "your_position": "Votre position",
        "drag_instruction": "Glissez le marqueur pour affiner votre position exacte"
      },
      "summary": {
        "items_count": "{{count}} article",
        "items_count_plural": "{{count}} articles",
        "subtotal_label": "Total :",
        "subtotal_ht": "Sous-total HT",
        "tva": "TVA (18 %)",
        "delivery_fee": "Frais de livraison",
        "service_fee": "Frais de service",
        "free": "Gratuit",
        "free_delivery_threshold": "Livraison gratuite à partir de {{amount}}",
        "total_ttc": "Total TTC"
      }
    },

    "whatsapp": {
      "confirm_cta": "Confirmer via WhatsApp",
      "payment_instruction": "Envoyez exactement",
      "payment_to": "au numéro {{provider}} CIEDA",
      "copy_number": "Copier le numéro",
      "copied": "Copié !",
      "merchant_number_unavailable": "Le numéro de paiement CIEDA n'est pas encore configuré. Contactez-nous au +221 76 604 22 74 pour finaliser la commande.",
      "next_steps_title": "Prochaines étapes",
      "step_pay": "Envoyez le paiement via {{provider}}",
      "step_confirm": "Nous confirmons votre commande sous 2h",
      "step_deliver": "Livraison dans votre zone",
      "reopen_whatsapp": "Rouvrir WhatsApp",
      "order_received": "Commande reçue !"
    }
  },

  "tracking": {
    "title": "Suivi de commande",
    "subtitle": "Entrez votre référence de commande pour suivre votre livraison.",
    "reference_placeholder": "Ex : CMD-20260215-0042",
    "search": "Rechercher",
    "reference_label": "Référence de commande",
    "ordered_on": "Commandé le",
    "not_found": "Commande introuvable. Vérifiez la référence et réessayez.",
    "estimated_delivery": "Livraison estimée :",
    "summary": "Récapitulatif de commande",
    "subtotal": "Sous-total",
    "tax": "TVA (18 %)",
    "total": "Total TTC",
    "status_pending": "En attente",
    "status_confirmed": "Confirmée",
    "status_processing": "En préparation",
    "status_shipped": "Expédiée",
    "status_delivered": "Livrée"
  }
}
